import { render, staticRenderFns } from "./DocumentGrid.vue?vue&type=template&id=39d3a869"
import script from "./DocumentGrid.vue?vue&type=script&lang=js"
export * from "./DocumentGrid.vue?vue&type=script&lang=js"
import style0 from "./DocumentGrid.vue?vue&type=style&index=0&id=39d3a869&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports